export const urlRegexp = /^(https?):\/\/[^\s$.?#].[^\s]*$/gi
